import * as actionTypes from '../actions/types';
import { updateObject } from '../../constants/utility';

const initialState = {
    isVGSCollectScriptLoading: false,
    isVGSCollectScriptSuccess: false,
    isVGSCollectScriptError: false,
    isVGSShowScriptLoading: false,
    isVGSShowScriptSuccess: false,
    isVGSShowScriptError: false,
    isBankInfoSubmissionFormCreated: false,
    VGSCollect: null,
    VGSShow: null,
};

const setIsVGSCollectScriptLoading = (state) =>
    updateObject(state, {
        isVGSCollectScriptLoading: true,
        isVGSCollectScriptError: false,
        isVGSCollectScriptSuccess: false,
        VGSCollect: null,
    });

const setIsVGSCollectScriptSuccess = (state, action) =>
    updateObject(state, {
        isVGSCollectScriptLoading: false,
        isVGSCollectScriptError: false,
        isVGSCollectScriptSuccess: true,
        VGSCollect: action.data,
    });

const setIsVGSCollectScriptError = (state) =>
    updateObject(state, {
        isVGSCollectScriptLoading: false,
        isVGSCollectScriptError: true,
        isVGSCollectScriptSuccess: false,
        VGSCollect: null,
    });

const setIsVGSShowScriptLoading = (state) =>
    updateObject(state, {
        isVGSShowScriptLoading: true,
        isVGSShowScriptError: false,
        isVGSShowScriptSuccess: false,
        VGSShow: null,
    });

const setIsVGSShowScriptSuccess = (state, action) =>
    updateObject(state, {
        isVGSShowScriptLoading: false,
        isVGSShowScriptError: false,
        isVGSShowScriptSuccess: true,
        VGSShow: action.data,
    });

const setIsVGSShowScriptError = (state) =>
    updateObject(state, {
        isVGSShowScriptLoading: false,
        isVGSShowScriptError: true,
        isVGSShowScriptSuccess: false,
        VGSShow: null,
    });

const setIsBankInfoSubmissionFormCreated = (state, action) =>
    updateObject(state, {
        isBankInfoSubmissionFormCreated: action.data,
    });

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_IS_VGS_COLLECT_SCRIPT_LOADING:
            return setIsVGSCollectScriptLoading(state);
        case actionTypes.SET_IS_VGS_COLLECT_SCRIPT_SUCCESS:
            return setIsVGSCollectScriptSuccess(state, action);
        case actionTypes.SET_IS_VGS_COLLECT_SCRIPT_ERROR:
            return setIsVGSCollectScriptError(state);
        case actionTypes.SET_IS_VGS_SHOW_SCRIPT_LOADING:
            return setIsVGSShowScriptLoading(state);
        case actionTypes.SET_IS_VGS_SHOW_SCRIPT_SUCCESS:
            return setIsVGSShowScriptSuccess(state, action);
        case actionTypes.SET_IS_VGS_SHOW_SCRIPT_ERROR:
            return setIsVGSShowScriptError(state);
        case actionTypes.SET_IS_BANK_INFO_SUBMISSION_FORM_CREATED:
            return setIsBankInfoSubmissionFormCreated(state, action);
        default:
            return state;
    }
};

export default reducer;
